;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var View = APP.module('View');

	View.TippingLeaguesAbout = View.LeaguesAbout.extend({
		template:   JST.ExtendTippingLeaguesAboutForAflClubs,
		ui:         {
			'leave_btn': '.js-leave',
			'search':    '.js-search-member'
		},
		initialize: function () {
			this.scrollToTop();
			this.league_id        = this.getOption('league_id');
			this.league           = this.getOption('league');
			this.user             = this.getOption('user');
			this.leagueJoined     = this.getOption('joined_users');
			this.rounds           = this.getOption('rounds');
			this.limit            = 50;
			this.show_more_status = false;

			this.enableSearchingProcess();

			this.listenTo(this.league, 'sync', this.broadcastLeague);
			this.listenTo(this.league, 'leagues:leave:errors', this.leagueLeaved);
			this.listenTo(this.league, 'leagues:leave:success', this.leagueLeaved);
			this.listenTo(APP.vent, 'leagues_manage_controls:change_league', this.changeLeague);

			var complete = [
				this.league.show().fetch({data: {id: this.league_id}}),
				this.leagueJoined.show().fetch({data: {league_id: this.league_id, offset: 0, limit: this.limit}}),
				this.rounds.fetch()
			];

			$.when.apply(null, complete).done(_.bind(this.initTemplate, this));
		},

		initTemplate: function() {

			this.trigger('leagues:view:menu', this.league);
			this.trigger('rounds:fetched', this.rounds);

			if (this.initData().isCanAccess()) {
				return this.setModelData().render();
			}

			return this;
		}
	});

}(window, APP, Backbone, Marionette, $, _));